import { Loading } from 'solid-js';
import { Router } from './router';
import Root from './app/Root';
import './styles/index.css';

// The app root rendered by the generated entries (server and client). The
// render-prop child is the site shell; matched pages render as props.children.
export default function App() {
  return (
    <Router>
      {(props) => (
        <Root>
          <Loading fallback={<div class="container page-loading" aria-hidden="true" />}>
            {props.children}
          </Loading>
        </Root>
      )}
    </Router>
  );
}
